//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2         : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ReportsCommand: any = {
    CreateAuthByReport: Backofficebff + '/v1/reportslist/create-auth-by-report',
    CreateAuthByRole: Backofficebff + '/v1/reportslist/create-auth-by-role',
    CreateReportsListItem: Backofficebff + '/v1/reportslist/create-reports-listitem',
    DeleteAuthByReport: Backofficebff + '/v1/reportslist/delete-auth-by-report',
    DeleteAuthByRole: Backofficebff + '/v1/reportslist/delete-auth-by-role',
    DeleteReportListItem: Backofficebff + '/v1/reportslist/delete-reports-listitem',
    UpdateReportsListItem: Backofficebff + '/v1/reportslist/update-reports-listitem',
    UpdateAuthByRole: Backofficebff + '/v1/reportslist/update-auth-by-role',
};
